import { useQuery } from "@tanstack/react-query";
import { useUser, useOrganization } from "@clerk/clerk-react";
import type { Service } from "@onsemble/shared";
import { getServices } from "@/requests/services/get-services";
import { useUpdateService } from "@/requests/services/update-service";

interface UseServicesResult {
  services: Service[];
  isLoading: boolean;
  error: unknown;
  updateService: (
    serviceId: string,
    data: { cost?: number; title?: string },
  ) => Promise<any>;
}

export const useServices = (): UseServicesResult => {
  const { user } = useUser();
  const { organization } = useOrganization();

  const { data, isLoading, error } = useQuery({
    ...getServices(),
    enabled: !!user && !!organization,
  });

  const updateServiceMutation = useUpdateService();

  const updateService = async (
    serviceId: string,
    data: { cost?: number; title?: string },
  ) => {
    return updateServiceMutation.mutateAsync({ serviceId, data });
  };

  return {
    services: data || [],
    isLoading,
    error,
    updateService,
  };
};
